export default "__VITE_ASSET__BEOESSji__"